import React, { useState } from 'react';
import { X, Hash, Lock, MessageCircle } from 'lucide-react';

const CreateChannelModal = ({ onClose, onCreate }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    channel_type: 'public'
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onCreate(formData);
  };

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl shadow-2xl w-full max-w-md p-6 border border-cyan-500/30">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-cyan-500 to-blue-500 rounded-xl flex items-center justify-center shadow-lg shadow-cyan-500/30">
              <MessageCircle size={20} className="text-white" />
            </div>
            <h2 className="text-xl font-semibold text-white">
              Create Channel
            </h2>
          </div>
          <button
            onClick={onClose}
            className="p-2 bg-slate-700/50 hover:bg-red-500/20 rounded-lg transition text-slate-400 hover:text-red-400"
          >
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-cyan-300 mb-2">
              Channel Name
            </label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              className="w-full px-4 py-3 bg-slate-700/50 border border-cyan-500/30 rounded-xl text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-cyan-500/50 focus:border-cyan-500/50 transition"
              placeholder="e.g., general, announcements"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-cyan-300 mb-2">
              Description
            </label>
            <textarea
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              className="w-full px-4 py-3 bg-slate-700/50 border border-cyan-500/30 rounded-xl text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-cyan-500/50 focus:border-cyan-500/50 transition resize-none"
              placeholder="What's this channel about?"
              rows={3}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-cyan-300 mb-3">
              Channel Type
            </label>
            <div className="grid grid-cols-2 gap-3">
              <button
                type="button"
                onClick={() => setFormData({ ...formData, channel_type: 'public' })}
                className={`p-4 rounded-xl border transition-all ${
                  formData.channel_type === 'public'
                    ? 'bg-gradient-to-r from-cyan-500/30 to-blue-500/30 border-cyan-500/50 text-white'
                    : 'bg-slate-700/30 border-slate-600/50 text-slate-400 hover:border-cyan-500/30'
                }`}
              >
                <Hash size={24} className="mx-auto mb-2" />
                <div className="text-sm font-medium">Public</div>
                <div className="text-xs text-slate-400 mt-1">Anyone can join</div>
              </button>
              <button
                type="button"
                onClick={() => setFormData({ ...formData, channel_type: 'private' })}
                className={`p-4 rounded-xl border transition-all ${
                  formData.channel_type === 'private'
                    ? 'bg-gradient-to-r from-cyan-500/30 to-blue-500/30 border-cyan-500/50 text-white'
                    : 'bg-slate-700/30 border-slate-600/50 text-slate-400 hover:border-cyan-500/30'
                }`}
              >
                <Lock size={24} className="mx-auto mb-2" />
                <div className="text-sm font-medium">Private</div>
                <div className="text-xs text-slate-400 mt-1">Invite only</div>
              </button>
            </div>
          </div>

          <div className="flex gap-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-3 border border-cyan-500/30 text-cyan-300 rounded-xl hover:bg-cyan-500/10 transition font-medium"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 px-4 py-3 bg-gradient-to-r from-cyan-500 to-blue-500 text-white rounded-xl hover:from-cyan-600 hover:to-blue-600 transition font-medium shadow-lg shadow-cyan-500/30"
            >
              Create Channel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateChannelModal;
